import { Loader2 } from 'lucide-react'

const SearchLoader = () => (
  <div className="gap-xxs p-xxs flex items-center text-sm text-gray-500">
    <Loader2 size={14} className="animate-spin" />
    Searching…
  </div>
)

export default SearchLoader
